import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import SubmissionConfirmation from "./submissionConfirmation";
import OneMap from "onemapsg";
import moment from "moment";
import { ErrorOutlineIco } from "@speedoc/design-assets/build/icons";
import { setHours, setMinutes } from "date-fns";
import useGoogleMapsApi from "../../hooks/useGoogleApi";
import { GlobalStore } from "../../stores/global";
import axios from "axios";

/* global google */

const onemap = new OneMap();
const getAddress = async postalCode => {
  try {
    const response = await onemap.search.search({
      searchVal: postalCode,
      returnGeom: true,
      getAddrDetails: true
    });
    return response.results && response.results.length > 0 ? response.results[0] : response.results;
  } catch (e) {
    console.log(e);
  }
};

function CPlace(props) {
  const [loc, setLoc] = useState([]);
  const [showLoc, setShowLoc] = useState(false);
  const [tSearch, setTSearch] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowLoc(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  return (
    <div className={props.className}>
      <div>
        <div>{props.label}</div>
        {props.err && (
          <div className="inputError">
            <ErrorOutlineIco />
            <div>{props.err}</div>
          </div>
        )}
      </div>
      {!props.booked ? (
        <>
          <input
            value={props.value}
            name="location"
            aria-label="Search locations"
            ref={props.inputToRef}
            placeholder={props.placeholder}
            autoComplete="on"
            onClick={() => {
              setTSearch(
                setTimeout(() => {
                  if (props.value && props.value.trim().length >= 3) {
                    var service = new google.maps.places.AutocompleteService();
                    service.getPlacePredictions(
                      {
                        input: props.value.trim(),
                        componentRestrictions: { country: props.location.toLowerCase() }
                      },
                      function (predictions, status) {
                        if (status == google.maps.places.PlacesServiceStatus.OK) {
                          setLoc(predictions || []);
                          setShowLoc(true);
                        } else {
                          setLoc([]);
                          setShowLoc(false);
                        }
                      }
                    );
                  }
                }, 3000)
              );
            }}
            onChange={event => {
              clearTimeout(tSearch);
              setTSearch(
                setTimeout(() => {
                  if (event.target.value.trim().length >= 3) {
                    var service = new google.maps.places.AutocompleteService();
                    service.getPlacePredictions(
                      {
                        input: event.target.value.trim(),
                        componentRestrictions: { country: props.location.toLowerCase() }
                      },
                      function (predictions, status) {
                        if (status == google.maps.places.PlacesServiceStatus.OK) {
                          setLoc(predictions || []);
                          setShowLoc(true);
                        } else {
                          setLoc([]);
                          setShowLoc(false);
                        }
                      }
                    );
                  }
                }, 3000)
              );
              props.handleChangePostalCode(props.where, event.target.value);
            }}
          />
          {!!showLoc && (
            <div className="c-loc" ref={ref}>
              {loc?.map((it, idx) => {
                return (
                  <div
                    key={idx}
                    onClick={async () => {
                      Array.from(document.querySelectorAll(".tmp-map")).map(e => e.remove());
                      let tempMap = document.createElement("div");
                      tempMap.classList.add("tmp-map");
                      document.body.appendChild(tempMap);
                      let pyrmont = new google.maps.LatLng(-33.8665433, 151.1956316);

                      let map = new google.maps.Map(tempMap, { center: pyrmont, zoom: 15 });
                      let sv = new google.maps.places.PlacesService(map);
                      sv.getDetails(
                        {
                          placeId: it.place_id,
                          fields: ["formatted_address"]
                        },
                        (place, status) => {
                          Array.from(document.querySelectorAll(".tmp-map")).map(e => e.remove());
                          !!place && props.onPlaceChange && props.onPlaceChange(props.where, props.value, place);
                        }
                      );
                      setShowLoc(false);
                    }}>
                    {it.structured_formatting?.main_text
                      ? it.structured_formatting?.main_text + " " + (it.structured_formatting?.secondary_text || "")
                      : it.description}
                  </div>
                );
              })}
            </div>
          )}
        </>
      ) : props.valueAdd !== null ? (
        <input value={props.valueAdd} readOnly={true} />
      ) : null}
    </div>
  );
}

export default function BookingForm({ service, isMobile, setSubmittedMobile, bookedMobile, setBookedMobile, formUrl }) {
  const [bookedDate, setBookedDate] = useState(null);
  const [reason, setReason] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [contactName, setContactName] = useState("");
  const [fromUnitNo, setFromUnitNo] = useState("");
  const [toUnitNo, setToUnitNo] = useState("");
  const [contactUnitNo, setContactUnitNo] = useState("");
  const [remarks, setRemarks] = useState("");
  const [fromAddress, setFromAddress] = useState("");
  const [toAddress, setToAddress] = useState("");
  const [fromPlace, setFromPlace] = useState("");
  const [toPlace, setToPlace] = useState("");

  const [bookedDateError, setBookedDateError] = useState(null);
  const [fromPlaceError, setFromPlaceError] = useState(null);
  const [toPlaceError, setToPlaceError] = useState(null);
  const [reasonError, setReasonError] = useState(null);
  const [phoneNumberError, setPhoneNumberError] = useState(null);
  const [contactNameError, setContactNameError] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const setSubmittedMo = setSubmittedMobile;
  const booked = bookedMobile;
  const setBooked = setBookedMobile;
  const inputFromRef = useRef(null);
  const inputToRef = useRef(null);
  const googleMapsApi = useGoogleMapsApi();
  const { currentCountryCode } = GlobalStore.useState(c => c);
  const submissionSuccessText = "Request has been successfully sent!";
  const bottomText = "Our team will contact you shortly to confirm your request.";
  const downloadapplink = currentCountryCode.toLowerCase() + "/download";
  const downloadAppText = "NOTE: For Video Consultations, you will need to download the Speedoc App.";
  const selectedService =
    service.package === "Video Consult"
      ? "videoConsult"
      : service.package === "Doctor Visit"
      ? "doctorVisit"
      : service.package === "Nurse Visit"
      ? "nurseVisit"
      : service.package === "Ambulance"
      ? "ambulance"
      : "";

  const [initSearch, setInitSearch] = useState(false);
  const phoneExt = currentCountryCode.toUpperCase() === "MY" ? "+60" : "+65";
  const {} = service;

  useEffect(() => {
    setBooked(false);
    setSubmitted(false);
    setContactUnitNo("");
    setToUnitNo("");
    setFromUnitNo("");
    setReason("");
    setPhoneNumber("");
    setContactName("");
    setRemarks("");
    setBookedDate(null);
    setFromAddress("");
    setToAddress("");
    setFromPlaceError(null);
    setToPlaceError(null);
    setReasonError(null);
    setPhoneNumberError(null);
    setContactNameError(null);
    setBookedDateError(null);
    setFromPlace("");
    setToPlace("");
    setInitSearch(false);
  }, [service, setBooked]);

  function handleChangePostalCode(where, value, placeChangeValue) {
    if (placeChangeValue) {
      if (where === "to") {
        const place = placeChangeValue;
        const selectedAddress = place.formatted_address;

        setToPlace(selectedAddress);
        if (
          (/^Singapore [0-9]{6}$/g.test(inputToRef.current.value) || /^[0-9]{6}$/g.test(inputToRef.current.value)) &&
          currentCountryCode === "SG"
        ) {
          const postalCode = inputToRef.current.value.match(/[0-9]{6}/g);
          if (postalCode.length > 0) {
            handleInputPostalCode("to", postalCode[0]);
          }
        } else {
          setToAddress(selectedAddress);
        }
        setToPlaceError(null);
      }
      if (where === "from") {
        const place = placeChangeValue;
        const selectedAddress = place.formatted_address;

        setFromPlace(selectedAddress);
        if (
          (/^Singapore [0-9]{6}$/g.test(inputFromRef.current.value) ||
            /^[0-9]{6}$/g.test(inputFromRef.current.value)) &&
          currentCountryCode === "SG"
        ) {
          const postalCode = inputFromRef.current.value.match(/[0-9]{6}/g);
          if (postalCode.length > 0) {
            handleInputPostalCode("from", postalCode[0]);
          }
        } else {
          setFromAddress(selectedAddress);
        }
        setFromPlaceError(null);
      }
      return;
    }

    if (where === "from") {
      setFromPlace(value);
      setFromPlaceError("No Results");
    } else if (where === "to") {
      setToPlace(value);
      setToPlaceError("No Results");
    }
  }

  const handleInputPostalCode = async (where, value) => {
    const location = await getAddress(value);
    if (location.ROAD_NAME != null) {
      setToPlaceError(null);
      const add = location.BLK_NO + " " + location.ROAD_NAME + ", S" + location.POSTAL;
      const finalAddress = add.toLowerCase().replace(/^(.)|\s+(.)/g, c => c.toUpperCase());
      if (where === "from") {
        setFromPlace(finalAddress);
        setFromAddress(finalAddress);
        setFromPlaceError(null);
      } else if (where === "to") {
        setToPlace(finalAddress);
        setToAddress(finalAddress);
        setToPlaceError(null);
      }
    } else {
      setToPlaceError("Invalid");
    }
  };

  function handleChangeReason(value) {
    setReason(value);
    if (!value) {
      setReasonError(true);
    } else {
      setReasonError(null);
    }
  }

  function handleBooking() {
    if (!fromAddress) {
      setFromPlaceError("Required");
    }
    if (!toAddress) {
      setToPlaceError("Required");
    }
    if (!reason) {
      setReasonError(true);
    }
    if (!phoneNumber || phoneNumber.length < 8 || phoneNumber.length > 11) {
      setPhoneNumberError(true);
    }
    if (!bookedDate) {
      setBookedDateError(true);
    }
    if (
      (!fromPlaceError && !toPlaceError && !!bookedDate && !phoneNumberError) ||
      (!toPlaceError && !!reason && !!bookedDate && !phoneNumberError)
    ) {
      let elements = document.querySelectorAll(".pac-container");
      while (elements.length > 0) {
        elements[0].parentNode.removeChild(elements[0]);
        elements = document.querySelectorAll(".pac-container");
      }
      setBooked(true);
    }
  }

  function handleChangePhoneNumber(value) {
    setPhoneNumber(value);
    if (!value || value.length < 8 || value.length > 11) {
      setPhoneNumberError(true);
    } else {
      setPhoneNumberError(null);
    }
  }

  function handleChangeUnitNo(place, value) {
    if (place === "from") {
      setFromUnitNo(value);
    } else if (place === "to") {
      setToUnitNo(value);
    } else if (place === "contact") {
      setContactUnitNo(value);
    }
  }

  function handleChangeRemarks(value) {
    setRemarks(value);
  }

  function handleChangeContactName(value) {
    setContactName(value);
    if (!value) {
      setContactNameError(true);
    } else {
      setContactNameError(null);
    }
  }

  function handleChangeBookedDate(date) {
    const minTime = setHours(setMinutes(date, 0), service.startTime);
    if (date.getTime() >= minTime.getTime()) {
      setBookedDate(date);
    } else {
      setBookedDate(minTime);
    }

    if (!date || date < new Date()) {
      setBookedDateError(true);
    } else {
      setBookedDateError(null);
    }
  }

  async function handleSubmitRequest() {
    if (!fromAddress) {
      setFromPlaceError("Required");
    }
    if (!toAddress) {
      setToPlaceError("Required");
    }
    if (!reason) {
      setReasonError(true);
    }
    if (!phoneNumber) {
      setPhoneNumberError(true);
    }
    if (!bookedDate) {
      setBookedDateError(true);
    }
    if (!contactName) {
      setContactNameError(true);
    }
    if (
      (!fromPlaceError && !toPlaceError && !!bookedDate && !!phoneNumber && !!contactName) ||
      (!toPlaceError && !!reason && !!bookedDate && !!phoneNumber && !!contactName)
    ) {
      setSubmitted(true);
      setSubmittedMo(true);
      try {
        const formData = new FormData();
        formData.append("q3_for", reason);
        formData.append("q4_when", bookedDate);
        if (selectedService !== "ambulance") formData.append("q5_where", toAddress);
        formData.append("q6_contact", phoneNumber);
        formData.append("q7_contactName", contactName);
        formData.append("q8_unitNumber", contactUnitNo);
        formData.append("q9_serviceType", selectedService);
        if (selectedService === "ambulance") {
          formData.append("q10_to", toAddress);
          formData.append("q13_to13", toUnitNo);
          formData.append("q12_from", fromAddress);
          formData.append("q14_from14", fromUnitNo);
          formData.append("q15_remarks", remarks);
        }

        await axios.post(formUrl, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
      } catch (e) {
        console.info(e);
      }
    }
  }

  function handleBackClick() {
    setBooked(false);
    setSubmitted(false);
    setSubmittedMo(false);
    setContactUnitNo("");
    setToUnitNo("");
    setFromUnitNo("");
    setReason("");
    setPhoneNumber("");
    setContactName("");
    setRemarks("");
    setFromAddress("");
    setToAddress("");
    setBookedDate(null);
    setFromPlaceError(null);
    setToPlaceError(null);
    setReasonError(null);
    setPhoneNumberError(null);
    setContactNameError(null);
    setBookedDateError(null);
    setSubmitted(false);
    setSubmittedMo(false);
    setFromPlace("");
    setToPlace("");
    setInitSearch(false);
  }

  function filterPassedTime(time) {
    const buffer = parseInt(service.bufferTimeForBooking, 10);

    const currentDate = moment(new Date())
      .add(buffer ? buffer : 10, "m")
      .toDate();
    const selectedDate = new Date(time);

    return currentDate.getTime() < selectedDate.getTime();
  }

  return !isMobile ? (
    <div id="bookingContainer">
      {!service.useBookingForm ? (
        <div className="bookingForm">
          <div
            className="replacementMessage"
            dangerouslySetInnerHTML={{ __html: service.bookingFormReplacementMessage }}
          />
        </div>
      ) : (
        <div className="bookingForm">
          {/* {service.useBookingForm ? ( <> */}

          {service.package === "Ambulance" ? (
            <div className={`booking ${submitted ? "submit" : ""}`}>
              {!booked && !submitted ? (
                <>
                  <CPlace
                    className="fromPickupPlace"
                    location={currentCountryCode}
                    label="From"
                    booked={null}
                    value={fromPlace}
                    valueAdd={null}
                    err={fromPlaceError}
                    where={"from"}
                    placeholder={"Address"}
                    inputToRef={inputFromRef}
                    handleChangePostalCode={handleChangePostalCode}
                    onPlaceChange={(where, textVal, place) => {
                      handleChangePostalCode(where, textVal, place);
                    }}
                  />
                  <CPlace
                    className="toDropPlace"
                    location={currentCountryCode}
                    label="To"
                    booked={null}
                    value={toPlace}
                    valueAdd={null}
                    err={toPlaceError}
                    where={"to"}
                    placeholder={"Address"}
                    inputToRef={inputToRef}
                    handleChangePostalCode={handleChangePostalCode}
                    onPlaceChange={(where, textVal, place) => {
                      handleChangePostalCode(where, textVal, place);
                    }}
                  />
                </>
              ) : !submitted ? (
                <div className="ambulanceFromPlace">
                  <div className="address">
                    <span>{"From"}</span>
                    <div className="inputtedAddress">
                      <input value={fromAddress} readOnly={true} />
                    </div>
                  </div>
                  <input
                    value={fromUnitNo}
                    placeholder="Enter Unit No. (if applicable)"
                    onChange={event => handleChangeUnitNo("from", event.target.value)}
                  />
                </div>
              ) : (
                <div className="submitted">
                  <div className="purpose">
                    <div>{service.package}</div>
                    <div>{moment(bookedDate).format("DD/MM/YYYY HH:MM")}</div>
                  </div>
                  <div className="fromPlace">
                    <div>{"From"}</div>
                    <div className="address">
                      <input value={fromAddress} readOnly={true} />
                      <div>{fromUnitNo}</div>
                    </div>
                  </div>
                  <div className="toPlaceAmbulance">
                    <div>{"To"}</div>
                    <div className="address">
                      <input value={toAddress} readOnly={true} />
                      <div>{toUnitNo}</div>
                    </div>
                  </div>
                  <div className="contact">
                    <div>{contactName}</div>
                    <div>{phoneExt + phoneNumber}</div>
                  </div>
                </div>
              )}
              {!submitted && (
                <div className="dateTimePickUp">
                  <div>
                    <div>{"When"}</div>
                    {bookedDateError && (
                      <div className="inputError">
                        <ErrorOutlineIco />
                        <div>{"Invalid"}</div>
                      </div>
                    )}
                  </div>
                  <DatePicker
                    selected={bookedDate}
                    onChange={date => handleChangeBookedDate(date)}
                    dateFormat="dd/MM/yyyy h:mm aa"
                    showTimeSelect
                    filterTime={filterPassedTime}
                    timeIntervals={parseInt(service?.timeInterval, 10) || 10}
                    placeholderText="Date & Time"
                    minDate={new Date()}
                    onFocus={e => e.target.blur()}
                    minTime={setHours(setMinutes(new Date(), 0), service.startTime)}
                    maxTime={setHours(setMinutes(new Date(), 0), service.endTime)}
                  />
                </div>
              )}
            </div>
          ) : !submitted ? (
            <div className="booking">
              <div className="fromPlace">
                <div>
                  <div>{"For"}</div>
                  {reasonError && (
                    <div className="inputError">
                      <ErrorOutlineIco />
                      <div>{"Required"}</div>
                    </div>
                  )}
                </div>
                <input
                  value={reason}
                  placeholder="Condition, symptom, procedure"
                  onChange={event => handleChangeReason(event.target.value)}
                />
              </div>
              <div className="dateTimePickUp">
                <div>
                  <div>{"When"}</div>
                  {bookedDateError && (
                    <div className="inputError">
                      <ErrorOutlineIco />
                      <div>{"Invalid"}</div>
                    </div>
                  )}
                </div>
                <DatePicker
                  selected={bookedDate}
                  onChange={date => handleChangeBookedDate(date)}
                  dateFormat="dd/MM/yyyy h:mm aa"
                  showTimeSelect
                  filterTime={filterPassedTime}
                  timeIntervals={parseInt(service?.timeInterval, 10) || 10}
                  placeholderText="Date & Time"
                  minDate={new Date()}
                  onFocus={e => e.target.blur()}
                  minTime={setHours(setMinutes(new Date(), 0), service.startTime)}
                  maxTime={setHours(setMinutes(new Date(), 0), service.endTime)}
                />
              </div>
              <CPlace
                className="toPlace"
                location={currentCountryCode}
                label="Where"
                booked={booked}
                value={toPlace}
                valueAdd={toAddress}
                err={toPlaceError}
                where={"to"}
                placeholder={"Address"}
                inputToRef={inputToRef}
                handleChangePostalCode={handleChangePostalCode}
                onPlaceChange={(where, textVal, place) => {
                  handleChangePostalCode(where, textVal, place);
                }}
              />
            </div>
          ) : (
            <div className="submitted">
              <div className="purpose">
                <div>{service.package}</div>
                <div>{moment(bookedDate).format("DD/MM/YYYY HH:mm")}</div>
              </div>
              <div className="reason">
                <div>{"Reasons"}</div>
                <div>{reason}</div>
              </div>
              <div className="toPlace">
                <div>{toAddress}</div>
                <div>{contactUnitNo}</div>
              </div>
              <div className="contact">
                <div>{contactName}</div>
                <div>{phoneExt + phoneNumber}</div>
              </div>
            </div>
          )}
          {!submitted && (
            <div className={service.package === "Ambulance" && booked ? "ambulanceContact" : "contact"}>
              <div>
                <div>{"Contact"}</div>
                {phoneNumberError && (
                  <div className="inputError">
                    <ErrorOutlineIco />
                    <div>{"Invalid"}</div>
                  </div>
                )}
              </div>
              <input
                type="number"
                value={phoneNumber}
                placeholder="Mobile"
                onChange={event => handleChangePhoneNumber(event.target.value)}
              />
            </div>
          )}
          {booked && !submitted && service.package === "Ambulance" && (
            <div className="ambulanceContactName">
              <div>
                <div>{"Contact Name"}</div>
                {contactNameError && (
                  <div className="inputError">
                    <ErrorOutlineIco />
                    <div>{"Required"}</div>
                  </div>
                )}
              </div>
              <input
                value={contactName}
                placeholder="Enter contact name"
                onChange={event => handleChangeContactName(event.target.value)}
              />
            </div>
          )}
          <div className={!booked ? "btnBooking" : "booked"} onClick={handleBooking}>
            <span>{"Book"}</span>
          </div>
        </div>
      )}
      {service.useBookingForm && booked && !submitted && (
        <div className="submitBooking">
          {service.package === "Ambulance" ? (
            <>
              <div className="toPlace">
                <div className="address">
                  <span>{"To"}</span>
                  <div className="inputtedAddress">
                    <input value={toAddress} readOnly={true} />
                  </div>
                </div>
                <input
                  value={toUnitNo}
                  placeholder="Enter Unit No. (if applicable)"
                  onChange={event => handleChangeUnitNo("to", event.target.value)}
                />
              </div>
              <div className="remarks">
                <div>{"Remarks"}</div>
                <input
                  value={remarks}
                  placeholder="E.g. Ward Lobby"
                  onChange={event => handleChangeRemarks(event.target.value)}
                />
              </div>
            </>
          ) : (
            <>
              <div className="contactName">
                <div>
                  <div>{"Contact Name"}</div>
                  {contactNameError && (
                    <div className="inputError">
                      <ErrorOutlineIco />
                      <div>{"Required"}</div>
                    </div>
                  )}
                </div>
                <input
                  value={contactName}
                  placeholder="Enter contact name"
                  onChange={event => handleChangeContactName(event.target.value)}
                />
              </div>
              <div className="unitNumber">
                <div>{"Unit number"}</div>
                <input
                  value={contactUnitNo}
                  placeholder="Enter Unit No."
                  onChange={event => handleChangeUnitNo("contact", event.target.value)}
                />
              </div>
            </>
          )}
          <div className="submitRequestBtn" onClick={handleSubmitRequest}>
            {"Confirm Request"}
          </div>
        </div>
      )}
      {service.useBookingForm && submitted && (
        <div className="submitBooking">
          <SubmissionConfirmation data={{ submissionSuccessText }} handleBackClick={handleBackClick} />
          {service.package === "Video Consult" ? (
            <div className="videoText">
              <a href={downloadapplink} target="_blank" rel="noreferrer">
                {downloadAppText}
              </a>
            </div>
          ) : (
            <div className="submitText">{bottomText}</div>
          )}
          <div className="backBtn" onClick={handleBackClick}>
            {"Back"}
          </div>
        </div>
      )}
    </div>
  ) : (
    <div className="bookingContainerMobile">
      {!service.useBookingForm ? (
        <div className="bookingMobile">
          <div
            className="replacementMessageMobile"
            dangerouslySetInnerHTML={{ __html: service.bookingFormReplacementMessage }}
          />
        </div>
      ) : (
        <>
          {!booked ? (
            <div className="bookingMobile">
              {service.package !== "Ambulance" ? (
                <div className="bookingFormMobile">
                  <div className="reason">
                    <div>
                      <div className="reasonMobile">{"For"}</div>
                      {reasonError && (
                        <div className="inputError">
                          <ErrorOutlineIco />
                          <div>{"Required"}</div>
                        </div>
                      )}
                    </div>
                    <input
                      value={reason}
                      placeholder="Condition, symptom, procedure"
                      onChange={event => handleChangeReason(event.target.value)}
                    />
                  </div>
                  <div className="timeAndPlace">
                    <div className="dateTimePickUp">
                      <div>
                        <div>{"When"}</div>
                        {bookedDateError && (
                          <div className="inputError">
                            <ErrorOutlineIco />
                            <div>{"Invalid"}</div>
                          </div>
                        )}
                      </div>
                      <DatePicker
                        selected={bookedDate}
                        onChange={date => handleChangeBookedDate(date)}
                        dateFormat="dd/MM/yyyy h:mm aa"
                        showTimeSelect
                        filterTime={filterPassedTime}
                        timeIntervals={parseInt(service?.timeInterval, 10) || 10}
                        placeholderText="Date & Time"
                        minDate={new Date()}
                        onFocus={e => e.target.blur()}
                        minTime={setHours(setMinutes(new Date(), 0), service.startTime)}
                        maxTime={setHours(setMinutes(new Date(), 0), service.endTime)}
                      />
                    </div>
                  </div>
                  <div className="timeAndPlace">
                    <CPlace
                      className="toPlace"
                      location={currentCountryCode}
                      label="Where"
                      booked={booked}
                      value={toPlace}
                      valueAdd={toAddress}
                      err={toPlaceError}
                      where={"to"}
                      placeholder={"Address"}
                      inputToRef={inputToRef}
                      handleChangePostalCode={handleChangePostalCode}
                      onPlaceChange={(where, textVal, place) => {
                        handleChangePostalCode(where, textVal, place);
                      }}
                    />
                  </div>
                </div>
              ) : (
                <div className="bookingFormMobileAmbulance">
                  <div className="dateTimePickUp">
                    <div>
                      <div className="datetimeHeaderMobile">{"When"}</div>
                      {bookedDateError && (
                        <div className="inputError">
                          <ErrorOutlineIco />
                          <div>{"Invalid"}</div>
                        </div>
                      )}
                    </div>
                    <DatePicker
                      selected={bookedDate}
                      onChange={date => handleChangeBookedDate(date)}
                      dateFormat="dd/MM/yyyy h:mm aa"
                      showTimeSelect
                      filterTime={filterPassedTime}
                      timeIntervals={parseInt(service?.timeInterval, 10) || 10}
                      placeholderText="Date & Time"
                      minDate={new Date()}
                      onFocus={e => e.target.blur()}
                      minTime={setHours(setMinutes(new Date(), 0), service.startTime)}
                      maxTime={setHours(setMinutes(new Date(), 0), service.endTime)}
                    />
                  </div>
                  <div className="fromToPlace">
                    <CPlace
                      className="fromPickupPlace"
                      location={currentCountryCode}
                      label="From"
                      booked={null}
                      value={fromPlace}
                      valueAdd={null}
                      err={fromPlaceError}
                      where={"from"}
                      placeholder={"Address"}
                      inputToRef={inputFromRef}
                      handleChangePostalCode={handleChangePostalCode}
                      onPlaceChange={(where, textVal, place) => {
                        handleChangePostalCode(where, textVal, place);
                      }}
                    />
                  </div>
                  <div className="fromToPlace">
                    <CPlace
                      className="toDropPlace"
                      location={currentCountryCode}
                      label="To"
                      booked={null}
                      value={toPlace}
                      valueAdd={null}
                      err={toPlaceError}
                      where={"to"}
                      placeholder={"Address"}
                      inputToRef={inputToRef}
                      handleChangePostalCode={handleChangePostalCode}
                      onPlaceChange={(where, textVal, place) => {
                        handleChangePostalCode(where, textVal, place);
                      }}
                    />
                  </div>
                </div>
              )}
              <div className="contactAndBook">
                <div className={service.package === "Ambulance" && booked ? "ambulanceContact" : "contact"}>
                  <div>
                    <div>{"Contact"}</div>
                    {phoneNumberError && (
                      <div className="inputError">
                        <ErrorOutlineIco />
                        <div>{"Invalid"}</div>
                      </div>
                    )}
                  </div>
                  <input
                    type="number"
                    value={phoneNumber}
                    placeholder="Mobile"
                    onChange={event => handleChangePhoneNumber(event.target.value)}
                  />
                </div>
                <div className={!booked ? "btnBooking" : "booked"} onClick={handleBooking}>
                  <span>{"Book"}</span>
                </div>
              </div>
            </div>
          ) : !submitted ? (
            <div className="submitBooking">
              {service.package !== "Ambulance" ? (
                <div className="submitMobile">
                  <div className="timePickup">
                    <div>
                      <div>{"When"}</div>
                      {bookedDateError && (
                        <div className="inputError">
                          <ErrorOutlineIco />
                          <div>{"Invalid"}</div>
                        </div>
                      )}
                    </div>
                    <DatePicker
                      selected={bookedDate}
                      onChange={date => handleChangeBookedDate(date)}
                      dateFormat="dd/MM/yyyy h:mm aa"
                      showTimeSelect
                      filterTime={filterPassedTime}
                      timeIntervals={parseInt(service?.timeInterval, 10) || 10}
                      placeholderText="Date & Time"
                      minDate={new Date()}
                      onFocus={e => e.target.blur()}
                      minTime={setHours(setMinutes(new Date(), 0), service.startTime)}
                      maxTime={setHours(setMinutes(new Date(), 0), service.endTime)}
                    />
                  </div>
                  <div className="patientName">
                    <div>
                      <div>{"Patient Name"}</div>
                      {contactNameError && (
                        <div className="inputError">
                          <ErrorOutlineIco />
                          <div>{"Required"}</div>
                        </div>
                      )}
                    </div>
                    <input
                      value={contactName}
                      placeholder={"Who"}
                      onChange={event => handleChangeContactName(event.target.value)}
                    />
                  </div>
                  <div className="locationAndUnit">
                    {!booked ? (
                      <CPlace
                        className="location"
                        location={currentCountryCode}
                        label="Location"
                        booked={booked}
                        value={toPlace}
                        valueAdd={null}
                        err={toPlaceError}
                        where={"to"}
                        placeholder={"Address"}
                        inputToRef={inputToRef}
                        handleChangePostalCode={handleChangePostalCode}
                        onPlaceChange={(where, textVal, place) => {
                          handleChangePostalCode(where, textVal, place);
                        }}
                      />
                    ) : (
                      <CPlace className="location" label="Location" location={currentCountryCode} value={toAddress} />
                    )}
                    <div className="unitNo">
                      <div>{"Unit"}</div>
                      <input
                        value={contactUnitNo}
                        placeholder={"Unit No"}
                        onChange={event => handleChangeUnitNo("contact", event.target.value)}
                      />
                    </div>
                  </div>
                  <div className="reason">
                    <div>
                      <div>{"Reason"}</div>
                      {reasonError && (
                        <div className="inputError">
                          <ErrorOutlineIco />
                          <div>{"Required"}</div>
                        </div>
                      )}
                    </div>
                    <input
                      value={reason}
                      placeholder={"Reason"}
                      onChange={event => handleChangeReason(event.target.value)}
                    />
                  </div>
                  <div className="contact">
                    <div>
                      <div>{"Contact"}</div>
                      {phoneNumberError && (
                        <div className="inputError">
                          <ErrorOutlineIco />
                          <div>{"Required"}</div>
                        </div>
                      )}
                    </div>
                    <input
                      value={phoneNumber}
                      placeholder={"Contact"}
                      onChange={event => handleChangePhoneNumber(event.target.value)}
                    />
                  </div>
                </div>
              ) : (
                <div className="submitMobileAmbulance">
                  <div className="timePickup">
                    <div>
                      <div>{"When"}</div>
                      {bookedDateError && (
                        <div className="inputError">
                          <ErrorOutlineIco />
                          <div>{"Invalid"}</div>
                        </div>
                      )}
                    </div>
                    <DatePicker
                      selected={bookedDate}
                      onChange={date => handleChangeBookedDate(date)}
                      dateFormat="dd/MM/yyyy h:mm aa"
                      showTimeSelect
                      filterTime={filterPassedTime}
                      timeIntervals={parseInt(service?.timeInterval, 10) || 10}
                      placeholderText="Date & Time"
                      minDate={new Date()}
                      onFocus={e => e.target.blur()}
                      minTime={setHours(setMinutes(new Date(), 0), service.startTime)}
                      maxTime={setHours(setMinutes(new Date(), 0), service.endTime)}
                    />
                  </div>
                  <div className="fromPlace">
                    <div className="address">
                      <div className="addressPlace">
                        <span>{"From"}</span>
                        <div className="inputtedAddress">
                          <input value={fromAddress} readOnly={true} />
                        </div>
                      </div>
                      <input
                        value={fromUnitNo}
                        placeholder="Enter Unit No. (if applicable)"
                        onChange={event => handleChangeUnitNo("from", event.target.value)}
                      />
                    </div>
                  </div>
                  <div className="toPlace">
                    <div className="address">
                      <div className="addressPlace">
                        <span>{"To"}</span>
                        <div className="inputtedAddress">
                          <input value={toAddress} readOnly={true} />
                        </div>
                      </div>
                      <input
                        value={toUnitNo}
                        placeholder="Enter Unit No. (if applicable)"
                        onChange={event => handleChangeUnitNo("to", event.target.value)}
                      />
                    </div>
                  </div>
                  <div className="contact">
                    <div className="contactName">
                      <div>
                        <div>{"Contact Name"}</div>
                        {contactNameError && (
                          <div className="inputError">
                            <ErrorOutlineIco />
                            <div>{"Required"}</div>
                          </div>
                        )}
                      </div>
                      <input
                        value={contactName}
                        placeholder="Enter contact name"
                        onChange={event => handleChangeContactName(event.target.value)}
                      />
                    </div>
                    <div className="contactNo">
                      <div>
                        <div>{"Contact No."}</div>
                        {phoneNumberError && (
                          <div className="inputError">
                            <ErrorOutlineIco />
                            <div>{"Invalid"}</div>
                          </div>
                        )}
                      </div>
                      <input
                        type="number"
                        value={phoneNumber}
                        placeholder="Contact No."
                        onChange={event => handleChangePhoneNumber(event.target.value)}
                      />
                    </div>
                  </div>
                  <div className="remarks">
                    <div>{"Remarks"}</div>
                    <input placeholder={"E.g. Ward Lobby"} />
                  </div>
                </div>
              )}
              <div className="submitText">{bottomText}</div>
              <div className="submitRequestBtn" onClick={handleSubmitRequest}>
                {"Confirm Request"}
              </div>
            </div>
          ) : (
            <div className="submitted">
              <SubmissionConfirmation data={{ submissionSuccessText }} handleBackClick={handleBackClick} />
              {service.package === "Ambulance" ? (
                <>
                  <div className="timeAndPurpose">
                    <div className={`purpose ${selectedService}`}>{service.package}</div>
                    <div>{moment(bookedDate).format("DD/MM/YYYY HH:mm")}</div>
                  </div>
                  <div className="fromPlace">
                    <div>{"From"}</div>
                    <div className="address">
                      <input value={fromAddress} readOnly={true} />
                      <div>{fromUnitNo}</div>
                    </div>
                  </div>
                  <div className="toPlace">
                    <div>{"To"}</div>
                    <div className="address">
                      <input value={toAddress} readOnly={true} />
                      <div>{toUnitNo}</div>
                    </div>
                  </div>
                  <div className="contact">
                    <div>{contactName}</div>
                    <div>{phoneExt + phoneNumber}</div>
                  </div>
                </>
              ) : (
                <>
                  <div className="timeAndPurpose">
                    <div className={`purpose ${selectedService}`}>{service.package}</div>
                    <div>{moment(bookedDate).format("DD/MM/YYYY HH:mm")}</div>
                  </div>
                  <div className="reason">
                    <div>{contactName}</div>
                    <div>{reason}</div>
                  </div>
                  <div className="address">
                    <div>{toAddress}</div>
                    <div>{contactUnitNo}</div>
                  </div>
                  <div className="contact">
                    <div>{"Contact No."}</div>
                    <div>{phoneExt + phoneNumber}</div>
                  </div>
                </>
              )}
              {service.package === "Video Consult" ? (
                <div className="videoText">
                  <a href={downloadapplink} target="_blank" rel="noreferrer">
                    {downloadAppText}
                  </a>
                </div>
              ) : (
                <div className="submitText">{bottomText}</div>
              )}
              <div className="backBtn" onClick={handleBackClick}>
                {"Go Back"}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
